import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const ProductContext = createContext();

const ProductContextProvider = (props) => {
  const [products, setProducts] = useState([]);
  const [mostBuyProducts, setmostBuyProducts] = useState([]);
  const [subcategoryProducts, setSubcategoryProducts] = useState([]);

  // Function to fetch products from the server
  const fetchProducts = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}product/all`
      );
      setProducts(response.data?.products);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };
  const fetchPBuyProducts = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}product/mostbought`
      );
      const data = await response.data;
      setmostBuyProducts(data.products);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    // Initial fetch
    fetchProducts();
    fetchPBuyProducts();

    const interval = setInterval(() => {
      fetchProducts();
      fetchPBuyProducts();
    }, 10000); // every 10 seconds

    return () => clearInterval(interval);

  }, []);

  return (
    <ProductContext.Provider
      value={{
        products,
        mostBuyProducts,
        subcategoryProducts,
        setSubcategoryProducts,
        fetchProducts,
        fetchPBuyProducts,
      }}
    >
      {props.children}
    </ProductContext.Provider>
  );
};

export default ProductContextProvider;
